<template>
    <!--    <common-page card-content flex-column>-->
    <div class="m-2 p-3" style="background-color: #FFFFFF;">
        <el-row>
            <el-col>
                <h3 style="color: #2662bb" class="ml-1">PPE领用申请</h3>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-row class="mb-1" v-show="false">
                    <el-col :span="24"><span>申请人ID：</span></el-col>
                </el-row>
                <el-row class="mb-1" v-show="false">
                    <el-col :span="24">
                        <el-input v-model="applyForm.userId" readonly></el-input>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>申请人工号：</span></el-col>
                </el-row>
                <el-row class="mb-2">
                    <el-col :span="24">
                        <el-input v-model="applyForm.employeeId" readonly></el-input>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>申请人姓名：</span></el-col>
                </el-row>
                <el-row class="mb-2">
                    <el-col :span="24">
                        <el-input v-model="applyForm.realName" readonly></el-input>
                    </el-col>
                </el-row>

                <el-row class="mb-1" v-show="false">
                    <el-col :span="24"><span>申请人部门ID：</span></el-col>
                </el-row>
                <el-row class="mb-1" v-show="false">
                    <el-col :span="24">
                        <el-input v-model="applyForm.deptId" readonly></el-input>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>申请人部门：</span></el-col>
                </el-row>
                <el-row class="mb-2">
                    <el-col :span="24">
                        <el-input v-model="applyForm.deptName" readonly></el-input>
                    </el-col>
                </el-row>


                <el-row>
                    <el-col>
                        <h3 style="color: #2662bb">领用PPE物品</h3>
                    </el-col>
                </el-row>
                <PpeApplyItem
                    :itemTypeName="itemTypeName1" :applyDetail="applyForm.applyDetailCloths" :options="clothsOption"
                    @add-detail="addDetailCloths" @remove-detail="removeDetailCloths"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName2" :applyDetail="applyForm.applyDetailShoes" :options="shoesOption"
                    @add-detail="addDetailShoes" @remove-detail="removeDetailShoes"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName3" :applyDetail="applyForm.applyDetailHelmet" :options="helmetOption"
                    @add-detail="addDetailHelmet" @remove-detail="removeDetailHelmet"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName4" :applyDetail="applyForm.applyDetailGloves" :options="glovesOption"
                    @add-detail="addDetailGloves" @remove-detail="removeDetailGloves"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName5" :applyDetail="applyForm.applyDetailGlasses"
                    :options="glassesOption"
                    @add-detail="addDetailGlasses" @remove-detail="removeDetailGlasses"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName6" :applyDetail="applyForm.applyDetailBreathe"
                    :options="breatheOption"
                    @add-detail="addDetailBreathe" @remove-detail="removeDetailBreathe"/>
                <PpeApplyItem
                    :itemTypeName="itemTypeName7" :applyDetail="applyForm.applyDetailHeight" :options="heightOption"
                    @add-detail="addDetailHeight" @remove-detail="removeDetailHeight"/>

                <el-row class="mb-1">
                    <el-col :span="24"><span>申请原因：</span><span class="text-danger">*</span></el-col>
                </el-row>
                <el-row class="mb-4">
                    <el-col :span="24">
                        <el-select v-model="applyForm.applyReason" clearable
                                   placeholder="-- 请选择申请原因 --"
                                   style="width: 100%;">
                            <el-option
                                v-for="item in dictApplyReasonOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>上次领用日期：</span>
                        <span class="text-danger">*</span>
                        <span class="text-danger">（新领用请选择当前日期）</span>

                    </el-col>
                </el-row>
                <el-row class="mb-4">
                    <el-col :span="24">
                        <el-date-picker v-model="applyForm.lastApplyDate" type="date" value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 100%;"></el-date-picker>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>其他补充内容：</span></el-col>
                </el-row>
                <el-row class="mb-4">
                    <el-col :span="24">
                        <el-input type="textarea" :rows="3" v-model="applyForm.applyRemark"></el-input>
                    </el-col>
                </el-row>

                <el-row class="mb-1">
                    <el-col :span="24"><span>上传旧PPE图片：</span></el-col>
                </el-row>
                <el-row class="mb-4">
                    <el-col :span="24">
                        <image-upload :action="action" auto-upload
                                      :ids="applyForm.attachments"
                                      @idsChange="whenUploadSuccess"></image-upload>
                    </el-col>
                </el-row>
                <el-row class="mb-4">
                    <el-col :span="24">
                        <el-button type="success" style="width: 100%;" @click="submitApply">PPE领用申请提交</el-button>
                    </el-col>
                </el-row>

            </el-col>
        </el-row>
    </div>
    <!--    </common-page>-->
</template>

<script>
import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import PpeApplyItem from './PpeApplyItem.vue';
import ImageUpload from "@/components/common/inputs/ImageUpload.vue";

export default {
    name: "PpeApply",
    components: {ImageUpload, PpeApplyItem},
    mixins: [emCommonListMixin, emCommonApiMixin],
    props: {
        action: {
            type: String,
            default: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/uploads"
        },
    },
    data() {
        return {
            itemTypeName1: '工服',
            itemTypeName2: '安全鞋',
            itemTypeName3: '安全帽',
            itemTypeName4: '手套',
            itemTypeName5: '护目类防护用品',
            itemTypeName6: '呼吸类防护用品',
            itemTypeName7: '登高防护用品',
            applyForm: {
                userId: null,
                loginName: null,
                employeeId: null,
                realName: null,
                deptId: null,
                deptName: null,
                lastApplyDate: null,
                applyReason: null,
                applyRemark: null,
                attachments: null,
                applyDetailCloths: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailShoes: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailHelmet: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailGloves: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailGlasses: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailBreathe: [{
                    id: null,
                    applyQuantity: null,
                }],
                applyDetailHeight: [{
                    id: null,
                    applyQuantity: null,
                }]
            },
            dictApplyReasonOption: [],
            inventoryQuantityMap: new Map(),
            clothsOption: [],   //工服
            shoesOption: [],    //安全鞋
            helmetOption: [],   //安全帽
            glovesOption: [],   //手套
            glassesOption: [],  //护目类防护用品
            breatheOption: [],  //呼吸类防护用品
            heightOption: [],  //呼吸类防护用品
        }
    },
    mounted() {
        this.getCurrentUserInfo();
        this.getDictApplyReason();
        this.getPpeInventory();
    },
    methods: {
        whenEditSuccess() {
            this.$router.push("/em/ppe/home");
        },
        getCurrentUserInfo() {
            this.$store.dispatch("api/get", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/emAclUser/currentUser"
            }, {
                root: true
            })
                .then(data => {
                    this.applyForm.userId = data.userId;
                    this.applyForm.loginName = data.loginName;
                    this.applyForm.employeeId = data.employeeId;
                    this.applyForm.realName = data.userRealName;
                    this.applyForm.deptId = data.deptId;
                    this.applyForm.deptName = data.deptName;
                })
        },
        getDictApplyReason() {
            let uri = `${this.$_emApiMixin_entityBaseApi('emDictData')}/findByFilter`;
            this.$_emApiMixin_post(uri, {
                dictTypeFilter: 'ppe_apply_reason'
            }).then((response) => {
                response.data.list.forEach((item) => {
                    this.dictApplyReasonOption.push({
                        value: item['id'],
                        label: item['dictLabel']
                    });
                });
            });
        },
        getPpeInventory() {
            this.$store.dispatch("api/post", {
                url: this.$store.state.ppeInventory.baseModuleUrl + "/ppeInventory/findByFilter",
                data: {
                    quantityGeFilter: 0
                }
            }).then(res => {
                //保存库存数据为map，用于判断库存量
                // 遍历列表，将 id 作为键，quantity 作为值存入 Map
                res.data.list.forEach(item => {
                    this.inventoryQuantityMap.set(item.id, item.quantity);
                });

                // 创建一个 Map 对象用于存储按物品类别分类后的map数据
                const groupedMap = new Map();
                // 遍历返回的数据
                res.data.list.forEach(item => {
                    const itemTypeName = item.itemTypeName;
                    // 检查 Map 中是否已经存在该 itemTypeName 对应的数组
                    if (!groupedMap.has(itemTypeName)) {
                        // 如果不存在，则创建一个新数组并存储到 Map 中
                        groupedMap.set(itemTypeName, []);
                    }
                    // 获取该 itemTypeName 对应的数组，并将当前项添加到数组中
                    const itemList = groupedMap.get(itemTypeName);
                    itemList.push(item);
                });
                //console.log("分类后存储在 Map 中的数据：", groupedMap);

                groupedMap.get('工服').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.clothsOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('安全鞋').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.shoesOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('安全帽').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.helmetOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('手套').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.glovesOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('护目类防护用品').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.glassesOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('呼吸类防护用品').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.breatheOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
                groupedMap.get('登高防护用品').forEach((item) => {
                    let itemModel = item['itemModel'] === undefined ? "" : " - 【" + item['itemModel'] + "】";
                    this.heightOption.push({
                        value: item['id'],
                        label: item['itemName'] + itemModel
                    });
                });
            })
        },
        addDetailCloths() {
            this.applyForm.applyDetailCloths.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailCloths(index) {
            this.applyForm.applyDetailCloths.splice(index, 1);
        },

        addDetailShoes() {
            this.applyForm.applyDetailShoes.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailShoes(index) {
            this.applyForm.applyDetailShoes.splice(index, 1);
        },
        addDetailHelmet() {
            this.applyForm.applyDetailHelmet.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailHelmet(index) {
            this.applyForm.applyDetailHelmet.splice(index, 1);
        },

        addDetailGloves() {
            this.applyForm.applyDetailGloves.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailGloves(index) {
            this.applyForm.applyDetailGloves.splice(index, 1);
        },

        addDetailGlasses() {
            this.applyForm.applyDetailGlasses.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailGlasses(index) {
            this.applyForm.applyDetailGlasses.splice(index, 1);
        },

        addDetailBreathe() {
            this.applyForm.applyDetailBreathe.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailBreathe(index) {
            this.applyForm.applyDetailBreathe.splice(index, 1);
        },

        addDetailHeight() {
            this.applyForm.applyDetailHeight.push({
                id: null,
                applyQuantity: null,
            });
        },
        removeDetailHeight(index) {
            this.applyForm.applyDetailHeight.splice(index, 1);
        },
        whenUploadSuccess(ids) {
            this.applyForm.attachments = ids.join(",");
        },
        submitApply() {
            // 申请表单验证
            const isValid = this.validateApplyForm(this.applyForm);
            if (!isValid) {
                // 如果验证不通过，直接返回，不进行提交
                return;
            }
            // 清理表单
            const validForm = this.clearApplyForm(this.applyForm);
            // console.log("================== 申请表单验证 ==================")
            // console.log(validForm)
            this.$store.dispatch("api/post", {
                url: this.$store.state.ppeApplyRecord.baseModuleUrl + "/ppeApplyRecord/handleMobileApplyForm",
                data: validForm
            }).then(res => {
                console.log("提交成功");
                console.log(res);
                this.$message.success("PPE领用申请提交成功");
                this.$router.push("/em/ppe/home");
            });
        },
        validateApplyForm(applyForm) {

            // 校验登录信息
            if (this.applyForm.loginName === null || this.applyForm.loginName === undefined) {
                this.$message.error("用户信息读取失败，请先登录！");
                return false;
            }

            // 校验物品领用清单
            const detailArrays = [
                'applyDetailCloths',
                'applyDetailShoes',
                'applyDetailHelmet',
                'applyDetailGloves',
                'applyDetailGlasses',
                'applyDetailBreathe',
                'applyDetailHeight'
            ];

            // 遍历每个子数组
            for (const arrayName of detailArrays) {
                const array = applyForm[arrayName];
                let convertItemName = '';
                switch (arrayName) {
                    case 'applyDetailCloths':
                        convertItemName = '工服';
                        break;
                    case 'applyDetailShoes':
                        convertItemName = '鞋';
                        break;
                    case 'applyDetailHelmet':
                        convertItemName = '头盔';
                        break;
                    case 'applyDetailGloves':
                        convertItemName = '手套';
                        break;
                    case 'applyDetailGlasses':
                        convertItemName = '护目类防护用品';
                        break;
                    case 'applyDetailBreathe':
                        convertItemName = '呼吸类防护用品';
                        break;
                    case 'applyDetailHeight':
                        convertItemName = '登高防护用品';
                        break;
                }
                // 遍历数组中的每个元素
                for (const item of array) {
                    // 检查 id 不为 null 的情况
                    if (item.id !== null) {
                        if (item.applyQuantity === null || item.applyQuantity === undefined || item.applyQuantity <= 0) {
                            // 抛出错误提示，这里可以根据实际情况修改为更友好的提示方式
                            this.$message.error(`请检查【${convertItemName}】领用申请表单，申请数量必须大于0。`);
                            return false;
                        }
                        const inventoryQuantity = this.inventoryQuantityMap.get(item.id);
                        if (inventoryQuantity < item.applyQuantity) {
                            // 抛出错误提示，这里可以根据实际情况修改为更友好的提示方式
                            this.$message.error(`请检查【${convertItemName}】申请表单，申请数量【${item.applyQuantity}】超出库存量 ${inventoryQuantity}，库存不足。`);
                            return false;
                        }
                    }
                }
            }

            // 校验申请原因是否选择
            if (this.applyForm.applyReason === null || this.applyForm.applyReason === undefined) {
                this.$message.error("请填写申请原因");
                return false;
            }
            // 校验上次申请日期是否选择
            if (this.applyForm.lastApplyDate === null || this.applyForm.lastApplyDate === undefined) {
                this.$message.error("请选择上次领用日期。如果是新领用，请选择当前日期。");
                return false;
            }
            return true;
        },
        clearApplyForm(applyForm) {
            const detailArrays = [
                'applyDetailCloths',
                'applyDetailShoes',
                'applyDetailHelmet',
                'applyDetailGloves',
                'applyDetailGlasses',
                'applyDetailBreathe',
                'applyDetailHeight'
            ];

            // 遍历每个子数组
            for (const arrayName of detailArrays) {
                const array = applyForm[arrayName];
                let newArray = [];
                // 遍历数组中的每个元素
                for (const item of array) {
                    // 检查 id 不为 null 的情况
                    if (item.id !== null && item.applyQuantity !== null && item.applyQuantity > 0) {
                        // 如果验证通过，将元素添加到新数组
                        newArray.push(item);
                    }
                }
                // 更新 applyForm 中的对应数组
                applyForm[arrayName] = newArray;
            }
            return applyForm;
        }
    },

}
</script>

<style scoped>

</style>
